module.exports = __webpack_public_path__ + "static/media/1.da7ea5f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/4007/1.jpg
// module id = 666
// module chunks = 0